// @flow

import * as React from "react";
import { Component } from "react";

import _ from "lodash";

type TimerState = {
  secondsElapsed: number
};

function WithTimer(WrappedComponent: React.ComponentType<Object>) {
  return class extends Component<Object, TimerState> {
    interval: ?IntervalID;

    constructor(props: Object) {
      super(props);
      this.interval = null;
      this.state = {
        secondsElapsed: 0,
        paused: false
      };
    }

    componentDidMount() {
      this.resume();
    }

    componentWillUnmount() {
      this.pause();
    }

    tick() {
      if (!this.props.paused) {
        this.setState(prevState => ({
          secondsElapsed: prevState.secondsElapsed + 0.1
        }));
      }
    }

    reset = () => {
      this.setState({ secondsElapsed: 0 });
    };

    pause = () => {
      const interval = this.interval;
      if (interval) {
        clearInterval(interval);
      }
    };

    resume = () => {
      this.interval = setInterval(() => this.tick(), 100);
    };

    render() {
      return (
        <WrappedComponent
          secondsElapsed={this.state.secondsElapsed}
          resetTimer={this.reset}
          pauseTimer={this.pause}
          resumeTimer={this.resume}
          {..._.omit(this.props, "paused")}
        />
      );
    }
  };
}

export default WithTimer;



// WEBPACK FOOTER //
// ./src/components/WithTimer/WithTimer.js